/**
 * IncidentFortifyIcon — bug shape with antennae.
 * Phase: incident-fortify.
 */

import type { ReactNode } from 'react';

interface IconProps {
  readonly size?: number;
  readonly color?: string;
}

export function IncidentFortifyIcon({ size = 18, color = '#F4EFE2' }: IconProps): ReactNode {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <ellipse cx="12" cy="13" rx="5" ry="6" />
      <path d="M7 13H4" />
      <path d="M20 13h-3" />
      <path d="M7 9.5l-2-2" />
      <path d="M19 7.5l-2 2" />
      <path d="M7 17l-2 2" />
      <path d="M17 17l2 2" />
      <path d="M9.5 6.5l1-2" />
      <path d="M14.5 6.5l-1-2" />
    </svg>
  );
}
